import React from 'react'
import Client from '../Client/Client'

const ClientDashbordHome = () => {
  return (
    <>
    <Client/>
    </>
  )
}

export default ClientDashbordHome
